import type { EditControlProps } from '../../declare'
import { useMemo } from 'react'
import { DatePicker } from 'src/components'
import { CONTROL_TYPE_mapto_DATE_TYPE } from 'src/components/root/helper'
import { $consts } from 'src/plugins'

const DateControl = (props: EditControlProps) => {
  const handleChange = (value: any) => {
    props.onChange?.(value)
  }

  const dateType = useMemo(() => {
    return CONTROL_TYPE_mapto_DATE_TYPE(props.config.CONTROL_TYPE)
  }, [props.config.CONTROL_TYPE])

  const format = useMemo(() => {
    return dateType === $consts['COMMON/DATE_TYPE_SECOND'] ? 'HH:mm:ss' : undefined
  }, [dateType])

  const { __READONLY__, EDITABLE } = props.config
  return (
    <DatePicker
      disabled={__READONLY__ || !EDITABLE}
      value={props.value}
      dateType={dateType}
      format={format}
      onChange={handleChange}
    />
  )
}

export default DateControl